import React, { useEffect } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';

// Layouts
import PublicLayout from './Components/PublicLayout';
import DashboardLayout from './Components/DashboardLayout';

// Public Pages
import Homepage from './pages/Homepage';
import AboutPage from './pages/AboutPage';
import CollectionsPage from './pages/CollectionsPage';
import ClientsPage from './pages/ClientsPage';
import InfrastructurePage from './pages/InfrastructurePage';
import ContactPage from './pages/ContactPage';
import ProductPage from './pages/ProductPage';
import SearchResults from './pages/SearchResults';
import NotFoundPage from './pages/NotFoundPage';

// Admin Pages
import LoginAdmin from './pages/LoginAdmin';
import AddProducts from './pages/AddProducts';
import CategoriesItemsAdmin from './pages/CategoriesItemsAdmin';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <>
      <ScrollToTop />
      <Routes>
        {/* Public routes with Header/Footer layout */}
        <Route element={<PublicLayout />}>
          <Route path="/" element={<Homepage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/collections" element={<CollectionsPage />} />
          <Route path="/clients" element={<ClientsPage />} />
          <Route path="/infrastructure" element={<InfrastructurePage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/product/:id" element={<ProductPage />} />
          <Route path="/search" element={<SearchResults />} />
        </Route>

        {/* Admin Login (no layout) */}
        <Route path="/LoginAdmin" element={<LoginAdmin />} />

        {/* Dashboard routes with sidebar layout */}
        <Route path="/Dashboard" element={<DashboardLayout />}>
          <Route index element={<Navigate to="/Dashboard/AddProducts" replace />} />
          <Route path="AddProducts" element={<AddProducts />} />
          <Route path="CategoriesItemsAdmin" element={<CategoriesItemsAdmin />} />
        </Route>

        {/* 404 */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </>
  );
}

export default App;
